import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Motion from '@/components/base/motion'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'

import { menuRevealAnimation } from './animations'

export type MenuProps = HTMLAttributes<HTMLElement> &
  Partial<{
    title: string
    caption: string
    list: {
      title: string
      description: string
    }[]
  }>

const Menu = ({ title, list = [], caption, ...props }: MenuProps) => {
  return (
    <Motion animation={menuRevealAnimation}>
      {(motionRef) => (
        <Section ref={motionRef} {...props}>
          <Container>
            <Grid className="gap-y-[3.2rem] text-center">
              {title ? (
                <div className="col-span-4 md:col-span-4 md:col-start-2 lg:col-span-8 lg:col-start-3">
                  <Typography
                    variant="h6"
                    component="h2"
                    className="font-timesnow"
                    data-motion-title
                  >
                    {title}
                  </Typography>
                </div>
              ) : null}

              <div className="col-span-4 md:col-span-4 md:col-start-2 lg:col-span-8 lg:col-start-3">
                <ul className="grid gap-y-[3.2rem]">
                  {list.map(({ title, description }, index) => (
                    <li key={`menu-item-${index}`}>
                      {title ? (
                        <div className="overflow-hidden">
                          <Typography
                            variant="label"
                            component="h3"
                            className="font-gillsans uppercase"
                            data-motion-name
                          >
                            {title}
                          </Typography>
                        </div>
                      ) : null}

                      {description ? (
                        <div className="overflow-hidden">
                          <Typography
                            variant="body"
                            paragraph
                            className="font-gillsans font-light"
                            data-motion-description
                          >
                            {description}
                          </Typography>
                        </div>
                      ) : null}
                    </li>
                  ))}
                </ul>
              </div>

              {caption ? (
                <div className="col-span-4 md:col-span-4 md:col-start-2 lg:col-span-8 lg:col-start-3">
                  <Typography
                    variant="label"
                    paragraph
                    className="font-gillsans font-light"
                    data-motion-caption
                  >
                    {caption}
                  </Typography>
                </div>
              ) : null}
            </Grid>
          </Container>
        </Section>
      )}
    </Motion>
  )
}

export default Menu
